import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["track"];

  connect() {
    this.fetchBrands();
  }

  async fetchBrands() {
    const apiUrl = "/api/v1/brands_only";

    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const brands = await response.json();
      this.renderBrands(brands);
    } catch (error) {
      console.error("Erreur lors de la récupération des marques:", error);
      // Fallback simple en cas d'erreur, ou laisser vide
      this.trackTarget.innerHTML = "";
    }
  }

  renderBrands(brands) {
    if (!brands || brands.length === 0) {
      return;
    }

    // Duplication pour l'effet de défilement infini (seamless loop)
    // On double la liste pour que l'animation translateX(-50%) fonctionne parfaitement
    const duplicatedBrands = [...brands, ...brands];

    const brandHtml = duplicatedBrands.map(brand => `
      <a href="/vitrine/brands/${brand.id}" class="brand-logo-item-link">
        <div class="brand-logo-item">
          <img src="${brand.image_url}" alt="${brand.name}"loading="lazy" />
        </div>
      </a>
    `).join('');

    this.trackTarget.innerHTML = brandHtml;

    // Observer le redimensionnement pour ajuster la vitesse d'animation
    this.observeResize();
  }

  observeResize() {
    if (this.resizeObserver) this.resizeObserver.disconnect();

    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        // requestAnimationFrame pour éviter les erreurs "ResizeObserver loop limit exceeded"
        requestAnimationFrame(() => {
          this.updateAnimationSpeed(entry.contentRect.width);
        });
      }
    });

    this.resizeObserver.observe(this.trackTarget);
  }

  updateAnimationSpeed(totalWidth) {
    if (!totalWidth || totalWidth === 0) return;

    // La distance parcourue correspond à la moitié de la largeur totale (car contenu dupliqué)
    const scrollDistance = totalWidth / 2;

    // Vitesse cible : 15 pixels par seconde (LENTE pour être visible)
    const speed = 15;

    // Durée = Distance / Vitesse
    let duration = scrollDistance / speed;

    // Sécurité pour ne pas avoir une animation trop rapide en cas de bug de calcul
    if (duration < 20) {
      duration = 60; // Fallback lent
    }

    this.trackTarget.style.animationDuration = `${duration}s`;
  }

  disconnect() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }
}